import "../../../../styles/ComponentsStyles/Setting/Profile/DocumentInfo.style.css";
import { useEffect, useState } from "react";
import FolderViewer from "./FolderViewer.component";
import FilesViewer from "./FilesViewer.component";
import { ReactComponent as BackBtnIcon } from "../../../../assets/Icons/Setting/Profile/BackButtonIcon.svg";
const DocumentInfo = () => {
  const [fileFolderHistory, setFileFolderHistory] = useState("");
  // eslint-disable-next-line
  const [fileSystem, setFileSystem] = useState([
    {
      name: "Students guide",
      isFolder: true,
      children: [
        { name: "Rules & regulation", isFolder: false },
        { name: "Instructions", isFolder: false },
      ],
    },
    {
      name: "Legal entity",
      isFolder: true,
      children: [
        { name: "Rules & regulation", isFolder: false },
        { name: "Ownership doc", isFolder: false },
        { name: "Registration form", isFolder: false },
      ],
    },
    {
      name: "Faculty documents",
      isFolder: true,
      children: [
        { name: "Teacher list", isFolder: false },
        { name: "Certification info", isFolder: false },
      ],
    },
    {
      name: "Exams",
      isFolder: true,
      children: [
        { name: "Results", isFolder: false },
        { name: "Time table", isFolder: false },
      ],
    },
    {
      name: "Events",
      isFolder: true,
      children: [
        { name: "Annual Day", isFolder: false },
        { name: "Sports Meet", isFolder: false },
        { name: "Rules & regulation", isFolder: false },
      ],
    },
  ]);
  const [filesData, setFilesData] = useState(null);
  useEffect(() => {
    if (fileFolderHistory !== "") {
      const filteredFileData = fileSystem.filter(
        (data) => data.name === fileFolderHistory
      );
      // console.log(filteredFileData);
      setFilesData(filteredFileData);
    }
  }, [fileFolderHistory, fileSystem]);
  // console.log();
  const [newFolderCreate, setNewFolderCreate] = useState("");
  console.log(newFolderCreate);

  return (
    <div className="flex-1 flex-col h-fit w-full  radius-10 back-white  align-left justify-start  pt-3 pb-2 pl-3 pr-3 g-2 overflow-hide">
      <div className="w-full flex-col align-left justify-start g-1">
        <div className="w-full flex-row align-center justify-between">
          <h3 className="t-16 color-grayColor poppins-medium weight-500">
            Document{fileFolderHistory !== "" && "/" + fileFolderHistory}
          </h3>
          {fileFolderHistory !== "" ? (
            <button
              type="button"
              title="Back"
              className="transparentBtn"
              onClick={() => setFileFolderHistory("")}
            >
              <BackBtnIcon style={{ width: "1.2rem", height: "1.2rem" }} />
            </button>
          ) : (
            ""
          )}
        </div>
        <hr color="#e5e5e5" className="w-full" />
      </div>

      <div className="adminProfileDocumentParentContainer w-full flex-1 scroll-y">
        {fileFolderHistory === "" ? (
          <FolderViewer
            data={fileSystem}
            setFileFolderHistory={setFileFolderHistory}
            handelNewFolder={(name) => setNewFolderCreate(name)}
          />
        ) : (
          <FilesViewer data={filesData && filesData[0]?.children} />
        )}
      </div>
    </div>
  );
};

export default DocumentInfo;
